module.exports = __webpack_public_path__ + "static/media/ml.bc4af821.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ml.svg
// module id = 190
// module chunks = 0